import firebase from "firebase/app";
import "firebase/analytics";
import "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyBsKFmgCYB0K4411sxHXNzXC8zXjXZf3qA",
    authDomain: "color-personality-e0413.firebaseapp.com",
    databaseURL: "https://color-personality-e0413.firebaseio.com",
    projectId: "color-personality-e0413",
    storageBucket: "color-personality-e0413.appspot.com",
    messagingSenderId: "719695151591",
    appId: "1:719695151591:web:5d30ea998a27e41316bd42",
    measurementId: "G-8D4CB1H7TJ"
};

const firebaseUtil = firebase.initializeApp(firebaseConfig);

export default firebaseUtil;